import { render, staticRenderFns } from "./button_demo.vue?vue&type=template&id=0bada3b3&scoped=true&"
import script from "./button_demo.vue?vue&type=script&lang=ts&"
export * from "./button_demo.vue?vue&type=script&lang=ts&"
import style0 from "./button_demo.vue?vue&type=style&index=0&id=0bada3b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bada3b3",
  null
  
)

export default component.exports